import { render, staticRenderFns } from "./TextLink.vue?vue&type=template&id=2288e15c&scoped=true&"
import script from "./TextLink.vue?vue&type=script&lang=js&"
export * from "./TextLink.vue?vue&type=script&lang=js&"
import style0 from "./TextLink.vue?vue&type=style&index=0&id=2288e15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288e15c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2288e15c')) {
      api.createRecord('2288e15c', component.options)
    } else {
      api.reload('2288e15c', component.options)
    }
    module.hot.accept("./TextLink.vue?vue&type=template&id=2288e15c&scoped=true&", function () {
      api.rerender('2288e15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/core/TextLink.vue"
export default component.exports